import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-219875f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col d-flex justify-content-between align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-5 mb-0" }, "Gestructureerde eigenschappen", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "general-feedback col-12 mb-4"
}
const _hoisted_11 = { class: "product-name row align-items-center mb-2" }
const _hoisted_12 = { class: "col-3 item-title" }
const _hoisted_13 = { class: "col-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 d-flex justify-content-between align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = { class: "col-12 d-flex justify-content-between align-items-center" }
const _hoisted_20 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_21 = { class: "badge bg-secondary text-black me-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_23 = {
  key: 0,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Commerciële naam", -1))
const _hoisted_25 = { class: "col-9" }
const _hoisted_26 = {
  key: 1,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_27 = { class: "col-3 item-title" }
const _hoisted_28 = { class: "col-9" }
const _hoisted_29 = {
  key: 2,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Doelgroep", -1))
const _hoisted_31 = { class: "col-9" }
const _hoisted_32 = {
  key: 3,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Eenheid", -1))
const _hoisted_34 = { class: "col-9" }
const _hoisted_35 = {
  key: 4,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Vorm", -1))
const _hoisted_37 = { class: "col-9" }
const _hoisted_38 = {
  key: 5,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Breedte", -1))
const _hoisted_40 = { class: "col-9" }
const _hoisted_41 = {
  key: 6,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Hoogte", -1))
const _hoisted_43 = { class: "col-9" }
const _hoisted_44 = {
  key: 7,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Diepte", -1))
const _hoisted_46 = { class: "col-9" }
const _hoisted_47 = {
  key: 8,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Gewicht", -1))
const _hoisted_49 = { class: "col-9" }
const _hoisted_50 = {
  key: 9,
  class: "internal-category row align-items-start mb-2"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 item-title" }, "Volume", -1))
const _hoisted_52 = { class: "col-9" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_54 = { class: "row" }
const _hoisted_55 = {
  key: 0,
  class: "col-12"
}
const _hoisted_56 = {
  key: 1,
  class: "col-lg-4"
}
const _hoisted_57 = { class: "card h-100" }
const _hoisted_58 = { class: "card-body d-flex flex-column" }
const _hoisted_59 = { class: "card-title" }
const _hoisted_60 = { class: "card-text" }
const _hoisted_61 = { class: "mt-auto" }
const _hoisted_62 = { class: "bg-warning missing-feature" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError = _resolveComponent("AlertError")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_PimFeedbackPanelOld = _resolveComponent("PimFeedbackPanelOld")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_ProductDetailPimTabTextFragmentCard = _resolveComponent("ProductDetailPimTabTextFragmentCard")!
  const _component_custom_names = _resolveComponent("custom-names")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError, {
      exceptions: _ctx.exceptions,
      class: "mb-3"
    }, null, 8, ["exceptions"]),
    (_ctx.AbilityContext.isAuthorizedForFeature('ADVANCED_MGMT_CUSTOMER_CATALOG_PRODUCTS'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.productInfo != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_MultilingualSwitcher, {
                  errors: [],
                  languages: _ctx.propertyLanguages,
                  "active-language": _ctx.customerPropertiesLanguageCode,
                  onUpdateActiveLanguage: _cache[0] || (_cache[0] = (newValue) => _ctx.switchLanguage(newValue))
                }, null, 8, ["languages", "active-language"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.productInfo != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _hoisted_7,
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-icon btn-primary ms-2",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isShowGeneralFeedback = !_ctx.isShowGeneralFeedback), ["prevent"]))
                              }, _hoisted_9)
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                            default: _withCtx(() => [
                              (_ctx.isShowGeneralFeedback)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(_component_PimFeedbackPanelOld, {
                                      "is-general-remark": true,
                                      onSubmitPimFeedback: _ctx.submitPimFeedback,
                                      onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                                    }, null, 8, ["onSubmitPimFeedback", "onSubmitPimFeedbackCancel"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('name')), 1),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.productName), 1),
                                        (!_ctx.customProductName)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                              _createVNode(_component_base_modal_button, {
                                                class: "btn btn-hover icon-link",
                                                "modal-id": "editCustomProductNameModalId",
                                                onClick: _ctx.onBeforeCustomProductNameModalOpened
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_17
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (_ctx.customProductName)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('ownContent')), 1),
                                              _createElementVNode("div", null, _toDisplayString(_ctx.customProductName), 1)
                                            ]),
                                            _createVNode(_component_base_modal_button, {
                                              class: "btn btn-hover icon-link",
                                              "modal-id": "editCustomProductNameModalId",
                                              onClick: _ctx.onBeforeCustomProductNameModalOpened
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_22
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.productInfo?.details?.commercial_name !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _hoisted_24,
                                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.productInfo?.details?.commercial_name), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.trademark !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('trademark')), 1),
                                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.productInfo?.details?.trademark?.description), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.target_group !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _hoisted_30,
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.productInfo?.details?.target_group?.description), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.unit !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _hoisted_33,
                                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.productInfo?.details?.unit?.description), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.shape !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _hoisted_36,
                                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.productInfo?.details?.shape), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.width !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _hoisted_39,
                                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.productInfo?.details?.width), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.height !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _hoisted_42,
                                      _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.productInfo?.details?.height), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.height !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _hoisted_45,
                                      _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.productInfo?.details?.height), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.weight !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _hoisted_48,
                                      _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.productInfo?.details?.weight), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.productInfo?.details?.volume !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      _hoisted_51,
                                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.productInfo?.details?.volume), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_53
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_54, [
            (_ctx.tabUI.isReady())
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "DESCRIPTION",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('DESCRIPTION'),
                    "customer-property": _ctx.findCustomerPropertyByCode('DESCRIPTION'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "APPLICATION",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('APPLICATION'),
                    "customer-property": _ctx.findCustomerPropertyByCode('APPLICATION'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "COMPOSITION",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('COMPOSITION'),
                    "customer-property": _ctx.findCustomerPropertyByCode('COMPOSITION'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "USAGE",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('USAGE'),
                    "customer-property": _ctx.findCustomerPropertyByCode('USAGE'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "INDICATION",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('INDICATION'),
                    "customer-property": _ctx.findCustomerPropertyByCode('INDICATION'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "CONTRA_INDICATION",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('CONTRA_INDICATION'),
                    "customer-property": _ctx.findCustomerPropertyByCode('CONTRA_INDICATION'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "PROPERTIES",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('PROPERTIES'),
                    "customer-property": _ctx.findCustomerPropertyByCode('PROPERTIES'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "PRESERVATION",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('PRESERVATION'),
                    "customer-property": _ctx.findCustomerPropertyByCode('PRESERVATION'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "DOSAGE",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('DOSAGE'),
                    "customer-property": _ctx.findCustomerPropertyByCode('DOSAGE'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"]),
                  _createVNode(_component_ProductDetailPimTabTextFragmentCard, {
                    "cnk-code": _ctx.cnkCodeAsInt,
                    "product-code": _ctx.productCode,
                    "text-fragment-name-code": "WARNING",
                    "named-text-fragments": _ctx.findTextFragmentsByCode('WARNING'),
                    "customer-property": _ctx.findCustomerPropertyByCode('WARNING'),
                    "customer-property-language-code": _ctx.customerPropertiesLanguageCode
                  }, null, 8, ["cnk-code", "product-code", "named-text-fragments", "customer-property", "customer-property-language-code"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_base_modal, {
            "modal-id": "editCustomProductNameModalId",
            title: _ctx.$t('name'),
            "no-footer": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_custom_names, {
                "product-code": _ctx.productCode,
                key: _ctx.editCustomProductNameModalKey,
                onSavedSuccessfully: _ctx.customNameSaved
              }, null, 8, ["product-code", "onSavedSuccessfully"]))
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("h5", _hoisted_59, _toDisplayString(_ctx.$t('catalogProductMgmtPim')), 1),
              _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t('catalogProductMgmtPimDesc')), 1),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1)
              ])
            ])
          ])
        ]))
  ], 64))
}